import store from "@/store";
import { startSilentAuth } from "./silentAuth";

export const applyInterceptors = (instance) => {
	instance.interceptors.request.use((config) => {
		const token = store.getters.getToken;
		if (token) config.headers.Authorization = token;
		return config;
	});

	instance.interceptors.response.use(
		(response) => response,
		async (error) => {
			const originalRequest = error.config;
			const isAuthenticating = store.getters.isAuthenticating;

			if (error.response?.status === 401 && !originalRequest._retry && !isAuthenticating) {
				originalRequest._retry = true;
				const result = await startSilentAuth();

				if (result.success) {
					store.dispatch("updateAuth", { token: result.token, user: JSON.parse(result.user) });
					return instance(originalRequest);
				} else {
					store.dispatch("clearAuth");
					return Promise.reject(error);
				}
			}

			return Promise.reject(error);
		}
	);
};
